<template>
  <div>
    <card class="mt-3 ml-auto mr-auto col-md-7 col-xs-12">
      <h4>World Friendship Fund Donations</h4>
      <div class="card-body">
        <div class="form-group">
          <label class="control-label">First Service</label>
          <fg-input
            name="service1"
            type="number"
            v-model="wffAmounts.Service1"
          >
            <template slot="addonLeft">
              $
            </template>
          </fg-input>
        </div>
        <div class="form-group">
          <label class="control-label">Second Service</label>
          <fg-input
            name="service2"
            type="number"
            v-model="wffAmounts.Service2"
          >
            <template slot="addonLeft">
              $
            </template>
          </fg-input>
        </div>
        <div class="row">
          <div class="col-6">
            <p-button
              type="success"
              title="Submit"
              @click="save"
            >
              Submit
            </p-button>
          </div>
          <div class="col-6 text-right">
            <p-button
              type="primary"
              title="Print Form"
              @click="print"
            >
              Print Form
            </p-button>
          </div>
        </div>
      </div>
    </card>
    <wff-report v-show="showPrint" />
  </div>
</template>

<script>
import wffApi from '@/services/api/world-friendship-fund.js'
import wffReport from '@/components/reports/report-world-friendship-fund.vue'

export default {
  name: 'WorldFriendshipFund',
  components: {
    wffReport
  },
  data: function () {
    return {
      wffAmounts: {},
      showPrint: false
    }
  },
  mounted: function () {
    wffApi.get(this.$root.courseKey)
      .then(x => {
        this.wffAmounts = x
      })
      .catch(error => {
        console.log(error)
        this.$notify({
          message: 'There was an error retrieving your data.',
          icon: 'bi bi-exclamation-circle-fill',
          type: 'error',
          horizontalAlign: 'center',
          timeout: 2000
        })
        this.errormessage = error
      })
      .finally(() => {
        this.loading = false
      })
  },
  methods: {
    save: function () {
      wffApi.update(this.wffAmounts)
        .then(x => {
          this.wffAmounts = x
          this.$notify({
            message: 'Update Complete',
            icon: 'nc-icon nc-satisfied',
            type: 'success',
            horizontalAlign: 'center',
            timeout: 2000
          })
        })
        .catch(error => {
          console.log(error)
          this.$notify({
            message: 'There was an error saving your information.',
            icon: 'bi bi-exclamation-circle-fill',
            type: 'error',
            horizontalAlign: 'center',
            timeout: 2000
          })
          this.errormessage = error
        })
        .finally(() => {
          this.loading = false
        })
    },
    print () {
      this.save()

      const printOptions = {
        styles: [
          '/kidlat.css',
          '/bootstrap.min.css',
          '/chalk-theme.css',
          '/printer-styles/two-beads-print.css',
          '/printer-styles/header-footer.css',
          '/printer-styles/world-friendship-fund.css'
        ]
      }

      this.$nextTick(function () {
        if (this.printItem !== '') {
          this.$htmlToPaper('wffReport', printOptions)
        }
        this.printItem = ''
      })
    }
  }
}
</script>
